import React, {
  useEffect,
  useState,
} from "react";

import AppModal from "./AppModal";

const TodoModal = ({
  show,
  setShow,
  editData,
  viewMode = false,
}) => {

  const [formData, setFormData] =
    useState({
      title: "",
      priority: "",
      date: "",
      assigned_to: "",
      status: "",
      description: "",
    });

  // Edit/View Data Fill
  useEffect(() => {

    if (editData) {

      setFormData({
        title:
          editData.title || "",
        priority:
          editData.priority || "",
        date:
          editData.date || "",
        assigned_to:
          editData.assigned_to || "",
        status:
          editData.status || "",
        description:
          editData.description || "",
      });

    } else {

      setFormData({
        title: "",
        priority: "",
        date: "",
        assigned_to: "",
        status: "",
        description: "",
      });

    }

  }, [editData, show]);

  // Input Change
  const handleChange = (e) => {

    const { name, value } =
      e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Submit
  const handleSubmit = () => {

    console.log(formData);

    setShow(false);
  };

  return (
    <AppModal
      show={show}
      setShow={setShow}
      title={
        viewMode
          ? "View Todo"
          : editData
            ? "Edit Todo"
            : "Add Todo"
      }
      size="modal-lg"
      footer={
        viewMode ? (
          <button
            className="btn btn-danger"
            onClick={() =>
              setShow(false)
            }
          >
            Close
          </button>
        ) : (
          <>
            <button
              className="btn btn-danger"
              onClick={() =>
                setShow(false)
              }
            >
              Cancel
            </button>

            <button
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              {editData
                ? "Update Todo"
                : "Save Todo"}
            </button>
          </>
        )
      }
    >

      <div className="row">

        {/* Todo Title */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Todo Title
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter todo title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            disabled={viewMode}
          />

        </div>

        {/* Assigned To */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Assigned To
          </label>

          <input
            type="text"
            className="form-control"
            placeholder="Assign user"
            name="assigned_to"
            value={formData.assigned_to}
            onChange={handleChange}
            disabled={viewMode}
          />

        </div>

        {/* Date */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Todo Date
          </label>

          <input
            type="date"
            className="form-control"
            name="date"
            value={formData.date}
            onChange={handleChange}
            disabled={viewMode}
          />

        </div>

        {/* Priority */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Priority
          </label>

          <select
            className="form-select"
            name="priority"
            value={formData.priority}
            onChange={handleChange}
            disabled={viewMode}
          >
            <option value="">
              Select Priority
            </option>

            <option value="High">
              High
            </option>

            <option value="Medium">
              Medium
            </option>

            <option value="Low">
              Low
            </option>

          </select>

        </div>

        {/* Status */}
        <div className="col-md-6 mb-3">

          <label className="form-label">
            Status
          </label>

          <select
            className="form-select"
            name="status"
            value={formData.status}
            onChange={handleChange}
            disabled={viewMode}
          >
            <option value="">
              Select Status
            </option>

            <option value="Pending">
              Pending
            </option>

            <option value="Completed">
              Completed
            </option>

          </select>

        </div>

        {/* Description */}
        <div className="col-md-12 mb-3">

          <label className="form-label">
            Description
          </label>

          <textarea
            rows="4"
            className="form-control"
            placeholder="Write todo description..."
            name="description"
            value={formData.description}
            onChange={handleChange}
            disabled={viewMode}
          ></textarea>

        </div>

      </div>

    </AppModal>
  );
};

export default TodoModal;